import { h, Component } from 'preact';
import style from './style';
import OTT from './../ott';
import ScreenController from './../screenController';
import Modal from './../spareparts/modal';
import * as Helper from './../helper';
import { regex } from './../config';

var wtPlay = document.getElementById('wtPlay');
var directTagID = document.querySelector('meta[name="wootag:direct_tag"]');
const HEAD = document.getElementsByTagName('head')[0];
const videoCSSFile = 'https://cdn.wootag.com/wootag/css/videojs/video-js.min.css';

const bridgeAPI = {
  playerReady: 'playerReady',
  setDuration: 'setDuration',
};

export default class Player extends Component {
  constructor(props) {
    super(props);

    let urlParams = Helper.getUrlParams(window.location.href);
    let meta = this.props.json && this.props.json.meta;
    if (props.json.config_data_json && props.json.config_data_json.abConfig) {
      const abConfig = props.json.config_data_json.abConfig;
      if (abConfig.tagPreviewTheme) {
        meta.tagPreviewTheme = abConfig.tagPreviewTheme;
      }
    }

    try {
      directTagID = props.displayDirectTag || parseInt(directTagID && directTagID.content, 10);
    } catch (e) {}

    this.state = {
      autopauseExceptions: [],
      autoplay: urlParams.autoplay === '1' || meta.thirdpartyapi,
      currentChapter: null,
      deeplinkTagId: urlParams.tagid || null,
      directTag: directTagID || (meta && meta.direct_tag_id),
      displayTag: false,
      editorMode: urlParams.editorMode === 'true',
      isFacebookAd: urlParams.fbAd === '1',
      noVideo: urlParams.noVideo === '1' || (meta && meta.direct_tag_id) || directTagID,
      scriptEmbed: urlParams.scriptEmbed === '1',
      ottOnly: urlParams.ottOnly === '1', // for mobile ads invideo links we pass the ottOnly=1 in parameter, which has two tasks, 1) making `ottWrapper` full width/height and 2) not loading the video
      popoverId: urlParams.popoverId || null,
      deactivateTag: false,
      decisionClose: false,
      modalChildren: null,
      modalProps: null,
      portraitVideo: false,
      ready: false,
      selectedTagIndex: null,
      showModal: false,
      showOTT: false,
      showSlideHint: false,
      showSwipeToast: false,
      tagHistory: null,
      videoActive: false,
      videoWidth: 0,
      videoHeight: 0,
      tagAutoInteraction: false,
      ageGateActive: false,
      fullWidthOTT: false,
      shareControllerIsOpen: false,
      tagPreviewThemeDark: (meta && meta.tagPreviewTheme === 'dark') ? 'tagPreviewThemeDark' : '',
      activeIndexForImageGallery: 0,
      originalWidth: 0,
      originalHeight: 0,
      tileModeStatus: false,
      isSquareVideo: false,
    };

    this.createCues = this.createCues.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.playVideo = this.playVideo.bind(this);
    this.pauseVideo = this.pauseVideo.bind(this);
    this.getCurrentTime = this.getCurrentTime.bind(this);
    this.hasVideoEnded = this.hasVideoEnded.bind(this);
    this.renderTag = this.renderTag.bind(this);
    this.unmountTag = this.unmountTag.bind(this);
    this.setCurrentTag = this.setCurrentTag.bind(this);
    this.destroyTag = this.destroyTag.bind(this);
    this.setVideoDimensions = this.setVideoDimensions.bind(this);
    this.receiveMessage = this.receiveMessage.bind(this);
    this.setDecisionCloseFalse = this.setDecisionCloseFalse.bind(this);
    this.setDeactivateTagFalse = this.setDeactivateTagFalse.bind(this);
    this.setTagAutoInteraction = this.setTagAutoInteraction.bind(this);
    this.setAgeGateActive = this.setAgeGateActive.bind(this);
    this.setFullWidthOTT = this.setFullWidthOTT.bind(this);
    this.disableSkinMode = this.disableSkinMode.bind(this);
    this.toggleTagForPortraitMode = this.toggleTagForPortraitMode.bind(this);
    this.shareControllerIsOpen = this.shareControllerIsOpen.bind(this);
    this.portraitTagTimer = null;
  }

  componentWillMount() {
    if (!this.state.noVideo) {
      this.importScreenLayout();
    } else {
      this.setVideoDimensions(0, 0, 0, 0);
    }
  }

  componentDidMount() {
    this.loadCSSPromise = Helper.loadCSS(videoCSSFile, HEAD);
    wtPlay = document.getElementById('wtPlay');

    setTimeout(() => {
      this.setState(
        {
          showSwipeToast: true,
        },
        () => {
          setTimeout(() => {
            this.setState({
              showSwipeToast: false,
            });
          }, 5000);
        }
      );
    }, 2000);

    // post message received from popover window---
    window.addEventListener('message', this.receiveMessage, false);

    if (!this.state.tagHistory) {
      let tags = this.props.json && this.props.json.otags;
      let tagHistory = {};
      tags.forEach((item, index) => {
        tagHistory[index] = 0;
      });

      this.setState({
        tagHistory,
      });
    }

    if (this.state.deeplinkTagId) {
      let ottInterval;
      if (!this.OTT) {
        if (ottInterval) {
          clearInterval(ottInterval);
        }
        ottInterval = setInterval(() => {
          if (this.OTT) {
            clearInterval(ottInterval);
            this.activateDirectTag(this.state.deeplinkTagId);
          }
        },500)
      } else {
        this.activateDirectTag(this.state.deeplinkTagId);
      }
    }
  }

  componentDidUnmount() {
    window.removeEventListener('message', this.receiveMessage, false);
  }

  render(props, state) {
    if (state.ready) {
      let facebookCheck = props.isFacebookApp ? 'fbapp' : '';
      let facebookAd = state.isFacebookAd ? 'fbAd' : '';
      let portraitVideoCheck = state.portraitVideo ? 'portraitVideo' : '';
      let tabletCheck = props.isTabletDevice ? 'tablet' : '';
      let isAd = props.isAd ? 'isAd' : '';
      let noVideo = state.noVideo ? 'noVideo' : '';
      let directTag = this.state.directTag ? 'enableDirectTag' : '';
      const shareControllerIsOpen = state.shareControllerIsOpen ? 'shareControllerIsOpen' : '';
      const tileModeStatus = state.tileModeStatus ? 'tileModeStatusEnabled' : '';
      const isSquareVideo = state.isSquareVideo ? 'squareVideo' : '';
      let klassList = `playerWrapper ${facebookCheck} ${facebookAd} ${portraitVideoCheck} ${tabletCheck} ${isAd} ${noVideo} ${directTag} ${shareControllerIsOpen} ${tileModeStatus} ${isSquareVideo}`;

      let ScreenTmpl = this.screenTmpl && this.screenTmpl.default;

      return (
        <div class={klassList} ref={(c) => (this.playerWrapper = c)}>
          {state.showOTT ? (
            <OTT
              {...props}
              ref={(c) => (this.OTT = c)}
              tags={props.json && props.json.otags}
              selectedTagIndex={state.selectedTagIndex}
              toggleModal={this.toggleModal}
              displayTag={state.displayTag}
              destroyTag={this.destroyTag}
              containerHeight={props.containerHeight}
              fbContainerHeightOffsetTop={props.fbContainerHeightOffsetTop}
              fbContainerHeightOffsetBottom={props.fbContainerHeightOffsetBottom}
              isAd={props.isAd}
              adUnits={props.adUnits}
              adUnitsArgs={props.adUnitsArgs}
              adType={props.adType}
              adUnitSrv={props.adUnitSrv}
              creativeData={props.creativeData}
              initAd={props.initAd}
              lsCards={state.renderLandscapeCards}
              hasDirectTag={state.directTag}
              videoId={props.json.video_id}
              deeplinkTagId={state.deeplinkTagId}
              isMobileDevice={props.isMobileDevice}
              isFacebookApp={props.isFacebookApp}
              isFacebookAd={state.isFacebookAd}
              noVideo={state.noVideo}
              ottOnly={state.ottOnly}
              forceStart={props.forceStart}
              scriptEmbed={state.scriptEmbed}
              deactivateTag={state.deactivateTag}
              decisionClose={state.decisionClose}
              setDecisionCloseFalse={this.setDecisionCloseFalse}
              setDeactivateTagFalse={this.setDeactivateTagFalse}
              postMessage={this.postMessage}
              orientation={props.orientation}
              portraitVideo={state.portraitVideo}
              renderLandscapeCards={this.renderLandscapeCards}
              os={props.os}
              editorMode={state.editorMode}
              removeLoader={props.removeLoader}
              playVideo={this.playVideo}
              pauseVideo={this.pauseVideo}
              hasVideoEnded={this.hasVideoEnded}
              getCurrentTime={this.getCurrentTime}
              videoWidth={state.videoWidth}
              videoHeight={state.videoHeight}
              logDataEvent={props.logDataEvent}
              fetchRedeemCode={props.fetchRedeemCode}
              handleChapterSelect={this.handleChapterSelect}
              trackEvent={props.trackEvent}
              handleAutoPauseException={this.handleAutoPauseException}
              toggleExpand={props.toggleExpand}
              eventBus={props.eventBus}
              setTagAutoInteraction={this.setTagAutoInteraction}
              tagAutoInteraction={this.state.tagAutoInteraction}
              ageGateActive={this.state.ageGateActive}
              setAgeGateActive={this.setAgeGateActive}
              fullWidthOTT={this.state.fullWidthOTT}
              setFullWidthOTT={this.setFullWidthOTT}
              updateJsonTag={props.updateJsonTag}
              displayAdClickThroughLink={props.displayAdClickThroughLink}
              disableSkinMode={this.disableSkinMode}
              activeIndexForImageGallery={state.activeIndexForImageGallery}
              originalWidth={state.originalWidth}
              originalHeight={state.originalHeight}
            />
          ) : null}

          {!state.noVideo ? (
            <ScreenController
              {...props}
              isAd={props.isAd}
              adUnits={props.adUnits}
              adUnitsArgs={props.adUnitsArgs}
              adType={props.adType}
              adUnitSrv={props.adUnitSrv}
              creativeData={props.creativeData}
              isMraidProject={props.isMraidProject}
              initAd={props.initAd}
              lsCards={state.renderLandscapeCards}
              cues={state.cues}
              createCues={this.createCues}
              renderTag={this.renderTag}
              renderLandscapeCards={this.renderLandscapeCards}
              unmountTag={this.unmountTag}
              destroyTag={this.destroyTag}
              setJSON={props.setJSON}
              setCurrentTag={this.setCurrentTag}
              resetAutoPauseExceptions={this.resetAutoPauseExceptions}
              setPlaybackState={this.setPlaybackState}
              getCurrentTime={this.getCurrentTime}
              tagHistory={state.tagHistory}
              updateTagHistory={this.updateTagHistory}
              containerHeight={props.containerHeight}
              fbContainerHeightOffsetTop={props.fbContainerHeightOffsetTop}
              fbContainerHeightOffsetBottom={props.fbContainerHeightOffsetBottom}
              playerWrapper={this.playerWrapper}
              isMobileDevice={props.isMobileDevice}
              isFacebookApp={props.isFacebookApp}
              isFacebookAd={state.isFacebookAd}
              noVideo={state.noVideo}
              ottOnly={state.ottOnly}
              isTagOpen={state.displayTag}
              orientation={props.orientation}
              portraitVideo={state.portraitVideo}
              autopauseExceptions={state.autopauseExceptions}
              autoplay={state.autoplay}
              deeplinkTagId={state.deeplinkTagId}
              editorMode={state.editorMode}
              forceMobileEmulation={props.forceMobileEmulation}
              forceDesktopEmulation={props.forceDesktopEmulation}
              setVideoDimensions={this.setVideoDimensions}
              removeLoader={props.removeLoader}
              trackEvent={props.trackEvent}
              logDataEvent={props.logDataEvent}
              eventBus={props.eventBus}
              setTagAutoInteraction={this.setTagAutoInteraction}
              tagAutoInteraction={this.state.tagAutoInteraction}
              network={props.network}
              playVideo={this.playVideo}
              pauseVideo={this.pauseVideo}
              ageGateActive={this.state.ageGateActive}
              setAgeGateActive={this.setAgeGateActive}
              fullWidthOTT={this.state.fullWidthOTT}
              setFullWidthOTT={this.setFullWidthOTT}
              screenReplay={this.screenReplay}
              updateJsonTag={props.updateJsonTag}
              clickThruLinks={props.displayAdClickThroughLink}
              disableSkinMode={this.disableSkinMode}
              deactivateTag={this.OTT && this.OTT.deactivateTag}
              hasVideoEnded={this.hasVideoEnded}
              toggleTagForPortraitMode={this.toggleTagForPortraitMode}
              shareControllerIsOpen={this.shareControllerIsOpen}
              tileModeStatus={this.tileModeStatus}
              videoWidth={state.videoWidth}
              videoHeight={state.videoHeight}
              setActiveIndexForImageGallery={this.setActiveIndexForImageGallery}
              setSquareVideo={this.setSquareVideo}
              ref={c => ( this.screenControllerRef = c)}
            >
              <ScreenTmpl ref={(c) => (this.screen = c)} />
            </ScreenController>
          ) : null}

          {state.showModal ? (
            <Modal {...state.modalProps} content={state.modalChildren} toggleModal={this.toggleModal} />
          ) : null}

          {state.isFacebookAd && state.showSlideHint ? (
            <div
              class={`player-toast ${state.showSwipeToast ? 'active' : ''}`}
              style={{ top: `${window.innerHeight - 60}px` }}
            >
              {'Swipe Left to see more'}
              <i class='zmdi zmdi-arrow-right'></i>
            </div>
          ) : null}

          <div class={`playerVideoTitle`}>{props.json && props.json.title}</div>
          <div class="tagPortraitContainer"></div>
        </div>
      );
    } else return null;
  }

  setSquareVideo = (isSquareVideo) => {
    this.setState({ isSquareVideo });
  }

  toggleTagForPortraitMode(show, handleClick = null, tagHTML = null) {
    const portraitTagContainer = document.querySelector('.tagPortraitContainer');
    if (!portraitTagContainer) return;
    if (show) {
      if (this.portraitTagTimer) {
        clearTimeout(this.portraitTagTimer)
        this.portraitTagTimer = null;
      };
      portraitTagContainer.innerHTML = tagHTML;
      portraitTagContainer.addEventListener('click', handleClick);
      if (this.state.tagPreviewThemeDark) portraitTagContainer.classList.add(this.state.tagPreviewThemeDark);
      setTimeout(() => {
        portraitTagContainer.classList.add('animatePortraitEntry');
      });
    } else {
      // hide current tag
      portraitTagContainer.classList.remove('animatePortraitEntry');
      portraitTagContainer.removeEventListener('click', handleClick);
      if (this.portraitTagTimer) return;
      this.portraitTagTimer = setTimeout(() => {
        portraitTagContainer.innerHTML = '';
      }, 100);
    }
  }

  shareControllerIsOpen(v) {
    this.setState({
      shareControllerIsOpen: v,
    });
  }

  disableSkinMode() {
    if (this.screenControllerRef) {
      this.screenControllerRef.disableSkinMode();
    }
  }

  importScreenLayout = () => {
    if (this.props.isAd) {
      import(/* webpackChunkName: "chunk-screenads-layout" */ `./../screenads`).then((res) => {
        this.screenTmpl = res;
        this.setState({ ready: true });
      });
    } else {
      import(/* webpackChunkName: "chunk-screen-layout" */ `./../screen`).then((res) => {
        this.screenTmpl = res;
        this.setState({ ready: true });
      });
    }
  };

  setVideoDimensions(videoWidth, videoHeight, originalWidth, originalHeight) {
    this.setState(
      {
        ready: true,
        showOTT: true,
        videoWidth,
        videoHeight,
        originalWidth,
        originalHeight,
        portraitVideo: originalHeight !== 0 && originalWidth !== 0 ? originalHeight >= originalWidth : false,
      },
      () => {
        if (!this.state.editorMode) {
          setTimeout(() => {
            if (this.state.directTag) {
              const tag = this.props.json.tags.find((tag) => tag.id === this.state.directTag);
              let trackers = document.querySelectorAll('meta[name="wootag:impression_tracker"]');
              if (!trackers.length) {
                trackers = this.props.displayImpTrackers;
              }

              if (trackers && trackers.length > 0) {
                trackers.forEach((tracker) => {
                  let url = tracker.content;
                  if (!regex.httpCheck.test(url)) {
                    url = `http://${url}`;
                  }

                  Helper.request(url);
                });
              }

              this.activateDirectTag(this.state.directTag);
              window.parent.postMessage(
                JSON.stringify({
                  api: bridgeAPI.playerReady,
                  data: null,
                }),
                '*'
              );

              this.props.logDataEvent({
                event: 'display_tag',
                event_type: 'impression',
                // host: '',
                tag_id: tag && tag.id,
                tag_label: (tag && tag.details.preview_title) || (tag && tag.details.title) || '',
              });
            }

            this.props.removeLoader();
          }, 800);
        }
      }
    );
  }

  receiveMessage = (event) => {
    let data = event && event.data;
    let decisionClose = false;
    let deactivateTag = false;

    try {
      data = typeof data !== 'object' ? JSON.parse(data) : data;
    } catch (e) {}

    if (data.tagid && this.state.noVideo) {
      this.openTagInFrame(data.tagid);
      this.setState({ deeplinkTagId: data.tagid });
    }

    if (data.tagid) {
      const tagId = data.tagid;
      const tags = this.props.json && this.props.json.otags;
      const dpTags = tags.filter((item) => (item && item.settings && item.settings.category) === 15);
      const isDPTag = dpTags.filter((item) => item.id === tagId);
      // Setting local state for if current active tag is a DP one---
      this.setState({ dpTagActive: isDPTag.length > 0 });
    }

    if ((data.time || data.time == 0) && (data.index || data.index == 0)) {
      this.handleChapterSelect(data.time, data.index);
    }

    if (data.decisionClose) {
      decisionClose = true;
      this.setState({ decisionClose });
    }

    if (data.deactivateTag) {
      deactivateTag = true;

      // if the current active tag is a DP one then only set decisionClose to true as decision handleClose
      // takes care of deactivateTag call---
      if (deactivateTag && this.state.dpTagActive) {
        this.setState({ decisionClose: true });
      } else {
        this.setState({ deactivateTag });
      }
    }
  };

  setDecisionCloseFalse = () => {
    this.setState({ decisionClose: false });
  };

  setDeactivateTagFalse = () => {
    this.setState({ deactivateTag: false });
  };

  postMessage = (obj) => {
    const objToPost = Object.assign(obj, { popoverId: this.state.popoverId });
    window.parent.postMessage(JSON.stringify(objToPost), '*');
  };

  toggleModal(showModal, modalChildren, modalProps) {
    this.setState({
      showModal,
      modalChildren,
      modalProps,
    });
  }

  createCues(isPreviewMode) {
    let cues = {};
    // in subtag cases the tag index remains the same but startTime can be after the next tag which causes issue as the values get overwritten.
    // example: tags = [{startTime:12, endTime:22},{startTime:6, endTiime:16},{startTime: 15, endTime:25}];
    // so in directly looping through the json.tags the first tag cues get overwritten by second and third tags duration.
    // to prevent that just took a copy of array to avoid mutation, looped through each item to add the original index of the tag, sorted as per the startTime and created cues;
    let tags = this.props.json.tags;
    if (isPreviewMode) {
      tags = Helper.filterTagsForDecisions(tags);
    }
    let tagsSortedAsPerStartTime = tags.slice(0);
    tagsSortedAsPerStartTime.forEach((item, index) => (item.index = index));
    tagsSortedAsPerStartTime.sort((a, b) => {
      return a.duration.tag_start_time - b.duration.tag_start_time;
    });

    tagsSortedAsPerStartTime.map((item, i) => {
      let startTime = item.duration.tag_start_time;
      let endTime = item.duration.tag_end_time;
      let type = item.settings.subcategory && item.settings.subcategory[0] && item.settings.subcategory[0].type;

      // once a tag disappears and next one shows the prev tag should not show again even if its duration allows.
      // to achieve that we set the last cue to minimum of its endTime and nextTag startTime-1;
      if (i + 1 < tagsSortedAsPerStartTime.length) {
        let nextTag = tagsSortedAsPerStartTime[i + 1];
        let nextTagStartTime = nextTag && nextTag.duration.tag_start_time;
        endTime = endTime > nextTagStartTime - 0.1 ? nextTagStartTime - 0.1 : endTime;
      }

      if (type === 1502) {
        let engagements = item.details.engagements && item.details.engagements[0];
        if (engagements && !engagements.dpnative) {
          endTime = startTime + 0.5;
        }
      }

      for (var i = startTime; i <= endTime; i = Helper.roundToX(i + 0.1, 1)) {
        cues[i] = item.index;
      }
    });

    return cues;
  }

  pauseVideo() {
    if (this.screen) {
      this.screen.pauseVideo();
    }
  }

  playVideo() {
    if (this.screen) {
      this.screen.playVideo();
    }
  }

  getCurrentTime = () => {
    return this.screen && this.screen.getCurrentTime();
  };

  screenReplay = () => {
    return this.screen && this.screen.handleReplay();
  };

  setCurrentTime = (time) => {
    if (this.screen) {
      this.screen.setTime(time);
      this.screen.playVideo();
      this.screen.hideSummaryCards();
    }
  };

  hasVideoEnded() {
    return this.screen && this.screen.hasVideoEnded();
  }

  handleAutoPauseException = (tag) => {
    this.setState({
      autopauseExceptions: [...this.state.autopauseExceptions, tag],
    });
  };

  resetAutoPauseExceptions = () => {
    this.setState({
      autopauseExceptions: [],
    });
  };

  openTagInFrame = (deeplinkTagId) => {
    let tags = (this.props.json && this.props.json.tags) || this.state.tags;
    let selectedTagIndex = deeplinkTagId && tags.findIndex((tag) => tag.id.toString() === deeplinkTagId.toString());
    let tag = tags[selectedTagIndex];
    let subcategory =
      tag && tag.settings.subcategory && tag.settings.subcategory[0] && tag.settings.subcategory[0].type;

    if (selectedTagIndex !== null && selectedTagIndex >= 0) {
      selectedTagIndex = this.props.isFacebookAd ? selectedTagIndex - 1 : selectedTagIndex;
    } else {
      selectedTagIndex = null;
    }

    let minIndex = this.props.isFacebookAd ? -1 : 0;
    if (selectedTagIndex !== null && selectedTagIndex >= minIndex && selectedTagIndex !== this.selectedTag) {
      if ((subcategory === 1401 || subcategory === 1403) && this.props.isFacebookAd) {
        this.setCurrentTag(selectedTagIndex, false);
        return;
      }

      this.renderTag(selectedTagIndex, true);
    }
  };

  renderTag(selectedTagIndex, toggleLock, trackerEvent, dontUpdateHistory) {
    let tagHistory = JSON.parse(JSON.stringify(this.state.tagHistory));

    if (!dontUpdateHistory) {
      tagHistory[selectedTagIndex] = 1;
    }

    this.setState(
      {
        displayTag: true,
        selectedTagIndex,
        tagHistory,
      },
      () => {
        if (this.OTT && selectedTagIndex !== undefined) {
          this.OTT.activateTag(selectedTagIndex + 1, toggleLock, trackerEvent);
        }
      }
    );
  }

  renderLandscapeCards = (renderLandscapeCards, selectedTagIndex) => {
    if (this.state.portraitVideo && this.props.isAd) {
      // this.screen.showSummaryCards();
    } else {
      this.pauseVideo();
      this.setState(
        {
          renderLandscapeCards,
        },
        () => {
          if (!this.state.renderLandscapeCards) {
            let hasVideoEnded = this.hasVideoEnded();
            if (!hasVideoEnded) {
              this.playVideo();
            }
          }
        }
      );
    }
  };

  setCurrentTag(tagIndex, toggleLock) {
    if (tagIndex !== undefined && this.OTT && this.OTT.setTagIndex) {
      this.OTT.setTagIndex(tagIndex + 1, toggleLock);
    }
  }

  updateTagHistory = (tagId) => {
    let tags = this.props.json && this.props.json.otags;
    let idx = tags.findIndex((item) => item.id === tagId);
    let tagHistory = this.state.tagHistory;

    tagHistory[idx] = 1;
    this.setState({
      tagHistory,
    });
  };

  unmountTag(dontPauseVideo) {
    this.screen.pauseVideo();
    this.setState(
      {
        displayTag: false,
      },
      () => {
        if (this.OTT) {
          this.OTT.deactivateTag(dontPauseVideo);
        }
        wtPlay.classList.remove('decisionpoint__enable');
      }
    );
  }

  destroyTag() {
    this.setState(
      {
        displayTag: false,
        selectedTagIndex: null,
      },
      () => {
        wtPlay.classList.remove('decisionpoint__enable');
      }
    );
  }

  setTagAutoInteraction(tagAutoInteraction) {
    this.setState({
      tagAutoInteraction,
    });
  }

  setAgeGateActive(visible) {
    this.setState({ ageGateActive: visible }, () => {
      if (visible) {
        this.pauseVideo();
        // when scrubbed ahead of start time of age gate it plays inspite of pausing so calling pause with a delay as a hack---
        setTimeout(() => {
          this.pauseVideo();
        }, 500);
      } else {
        this.playVideo();
      }
    });
  }

  setFullWidthOTT(fullWidthOTT) {
    this.setState({ fullWidthOTT });
  }

  activateDirectTag = (tagId) => {
    let selectedIndex = this.props.json.tags.findIndex((tag) => tag.id == tagId);
    if (this.OTT && selectedIndex > -1) {
      this.OTT.activateDirectTag(selectedIndex + 1);
    }
  };

  tileModeStatus = (status) => {
    this.setState({ tileModeStatus: status });
  }

  setActiveIndexForImageGallery = (index) => {
    this.setState({ activeIndexForImageGallery: index });
  };
}



// WEBPACK FOOTER //
// ./components/player/index.js